<div id="menugroup-container" class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <div class="menu-header-container">
    <div class="menu-header-container--content">
      <button a11y_Button id="scroll-left" (click)="scrollLeft()" [class.inactive]="atStart">
        <div class="inline-icon ya-tag-sort-icon-svg rotate" inlineSVG="shop-icons.svg#ya-chevron_right"></div>
      </button>
      <mat-tab-group #tabGroup id="headerTabs" mat-stretch-tabs class="ya-tab-group ya-tab-group--bodyless">
        <ng-container *ngFor="let itemGroup of itemGroups">
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="ya-tab-click" (click)="headerTabClick(itemGroup)">{{itemGroup.label}}</div>
            </ng-template>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
      <button a11y_Button id="scroll-right" (click)="scrollRight()" [class.inactive]="atEnd">
        <div class="inline-icon ya-tag-sort-icon-svg" inlineSVG="shop-icons.svg#ya-chevron_right"></div>
      </button>
      <ng-container *ngIf="isItemTagEnabled && itemTags && itemTags.length > 0">
      </ng-container>
    </div>
    <div class="ya-tag-sort-icon-container">
      <a a11y_Button class="ya-tag-sort-icon-button" matRipple matRippleCentered="true" (click)="openNavModal()">
        <div class="inline-icon ya-tag-sort-icon-svg modalmenu" inlineSVG="shop-icons.svg#ya-hypersoft-modalmenu"></div>
      </a>
    </div>
  </div>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset"
    [class.warenkorb-padding]="itemsInBasket > 0">
    <div class="scrollmenu">
      <ya-subheader [hasContent]="true" [disableNavigateBack]="true"
        (onNavigateBackClick)="navigateBack()"></ya-subheader>
      <ng-container *ngIf=" useRedeemCoupon && allowReedemCoupon">
        <div class="coupon_redeem">
          <div class="ya-button-container">
            <button a11y_Button class="coupon_btn--selection" (click)="navigateToCouponRedeem()">
              <span langkey="phCoupon_Redeem_Btn_Label"></span>
              <div class="inline-icon coupon-icon" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isItemTagEnabled && itemTags && itemTags.length > 0">
        <div class="ya-tag-sort-icon-container">
          <a a11y_Button class="ya-tag-sort-icon-button" matRipple matRippleCentered="true" (click)="openTagsModal()">
            <div class="inline-icon ya-tag-sort-icon-svg" inlineSVG="shop-icons.svg#ya-hypersoft-preferences-filter">
            </div>
            <ng-container *ngIf="hasTagSorting()">
              <div class="ya-checkmark-container">
                <div class="inline-icon ya-tag-checkmark-icon" inlineSVG="shop-icons.svg#ya-hypersoft-check-voll"></div>
              </div>
            </ng-container>
          </a>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="menugroup-item-container" #menugroupitemcontainer [class.item-container--grid]="isSmallView"
        (window:resize)="onResize($event)">
        <ng-container *ngFor="let itemGroup of itemGroups">
          <div class="menugroup-item">
            <a a11y_Button (click)="navigateToMenuList(itemGroup)">
              <div class="aspect-ratio-box menugroup-item__img">
                <div class="aspect-ratio-box-inside">
                  <div class="aspect-ration-img-box">
                    <img class="ya_image" [src]="itemGroup.imagePhoto" alt="" />
                  </div>
                </div>
              </div>
              <div class=menugroup-item__bar>
                <div class=menugroup-item__label>
                  <ng-container *ngIf="itemGroup.use_label">
                    <h3>{{itemGroup.label}}</h3>
                  </ng-container>
                </div>
                <div class=menugroup-item__forwardicon>
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-keyboard_backspace"></div>
                </div>
              </div>
            </a>
          </div>
        </ng-container>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
  <ng-container *ngIf="!isRemoteGroupOrder&&itemsInBasket > 0">
    <a @plopInOut routerLink="/webshop" class="warenkorb-btn" [matBadge]="itemsInBasket">
      <div class="text" langkey="phWebshop_View_Cart">
      </div>
      <div class="icon">
        <div id="header-icon-basket" class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
      </div>
    </a>
  </ng-container>
</div>